import { render, staticRenderFns } from "./AdminPaymentHistoryIndex.vue?vue&type=template&id=b55a5244"
import script from "./AdminPaymentHistoryIndex.vue?vue&type=script&lang=js"
export * from "./AdminPaymentHistoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports